import { Box, Divider, Stack, Typography } from "@mui/material"
import DOMPurify from 'dompurify'

export const Section = (props) => {
    const {name,align} = props
    return(
        <Stack sx={{width:'100%',margin:'20px 0 20px 0'}}>
            <Divider variant='middle' textAlign={align}>
                <Typography variant='h5' sx={{fontFamily:'sans-serif',fontWeight:600,color:'#56d1b2'}}>{name}</Typography>
            </Divider>
        </Stack>
    )
}

export class WordTransform {
    static getTransform(word='',color) {
        return word.split("@p").map((a,ia) => {
            return <Typography key={ia} variant="body2" paragraph sx={{textIndent:'30px',textAlign:'justify',fontFamily:'Segoe UI'}}>
                <Typography component={'span'}><Typography component={'span'} variant="h6" style={{color:color,fontWeight:700}}>{a.charAt(0).toUpperCase()}</Typography>{WordTransform.checkWord(a.substring(1),color)}</Typography>
            </Typography>
          })
    }
    static checkWord(word='',color='') {
        word = word.replace(/@b(.*?)b@/g,`<strong style="color:${color}"}>$1</strong>`)
        word = word.replace(/@i(.*?)i@/g,`<em style="color:${color}">$1</em>`)
        word = word.replace(/@u(.*?)u@/g,`<u style="color:${color}">$1</u>`)
        word = word.replace(/@link(.*?)link@\[(.*?)\]/g,`<a style="color:white;background:${color};border-radius:5px;padding:5px;text-decoration:none;'&hover':'color:green'" href="$1">$2</a>`)
        word = word.replace(/@ll(.*?)ll@/g,'<li style="text-indent:0px;">$1</li>')
        word = word.replace(/@l(.*?)l@/g,'<ol>$1</ol>')
        var sanitize = DOMPurify.sanitize(word,{ ADD_ATTR: ['style'] })
        return(
            <span dangerouslySetInnerHTML={{__html: sanitize}}/>
        )
    }
}

export const Panel = (props) => {
    const { value,validate,children } = props
    return(
        <Box sx={{display:(value === validate)?'block':'none'}}>
            {children}
        </Box>
    )
}